import { API } from '../../../config';
import { errorHandler } from '../auth/errorAction';

export const unmountListInstructor = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_INSTRUCTOR'})
}

export const unmountDetailInstructor = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_INSTRUCTOR'})
}

export const unmountMasterInstructor = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_INSTRUCTOR'})
}

export const listInstructor = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_INSTRUCTOR' })
  return API.GET('/instructor/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_INSTRUCTOR_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_INSTRUCTOR_FAILED' }), 
    ))
  })
}

export const detailInstructor = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_INSTRUCTOR' })
  const params = {
    'id': id
  }
  API.GET('/instructor/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_INSTRUCTOR_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_INSTRUCTOR_FAILED' }), 
      ))
    )
  })
}

export const masterInstructor = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_INSTRUCTOR' })
  return API.GET('/instructor/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_INSTRUCTOR_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: null,
          total: null,
          perpage: null
        }
    }})
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_INSTRUCTOR_FAILED' }), 
    ))
  })
}

export const createInstructor = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA('/instructor/add', value, 'createInstructor').then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const editInstructor = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA('/instructor/update', value, 'createInstructor').then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enableInstructor = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/instructor/enableUser', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disableInstructor = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/instructor/disableUser', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}